<div class="percent-input">
  <button type="button" (click)="onPlusClick()">+</button>
  <input #input [(ngModel)]="percentValue" appPercentFormatter type="text" [ngModelOptions]="{standalone: true}"
         oninput="this.value=this.value.replace(/[^0-9]/g,'')" (blur)="onBlur()" (keydown.enter)="input.blur()">
  <button type="button" (click)="onMinusClick()">-</button>
</div>
